import { Col, Row } from "antd";

const SqarePdf = ({ image, title, pdf, downloadName }) => {
  return (
    <Row
      style={{
        display: "flex",
        border: "1px solid lightgray",
        margin: "15px 15px",
      }}
    >
      <Col>
        <img
          style={{ height: "262px", width: "262px" }}
          src={image}
          alt={title}
        />
      </Col>

      <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
        <Col
          style={{
            width: "200px",
            lineHeight: "20px",
            color: "#505d68",
            fontWeight: "700",
          }}
        >
          {title}
        </Col>
        <Col>
          <a
            style={{
              marginTop: "15px",
              textDecoration: "underline",
              color: "#F32000",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
            }}
            href={pdf}
            download={downloadName}
          >
            Descargar
          </a>
        </Col>
      </Col>
    </Row>
  );
};

export default SqarePdf;
